import { createFileRoute } from "@tanstack/react-router";
import { WorkspacesPage } from "@/features/workspaces/WorkspacesPage";

/** P04 Workspaces: the workspace cards inside the app shell. */
export const Route = createFileRoute("/_app/workspaces")({
  component: WorkspacesPage,
});
